<script>
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  name: 'BarChart',
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: null,
      required: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>
